export interface SysConfig {
  /** api */
  baseUrl: string;
}
const SYSTEM_CONFIG_KEY = 'system_config_';

const systemStore = {
  get<T extends keyof SysConfig>(key: T): SysConfig[T] {
    let result = JSON.parse(window.localStorage.getItem(SYSTEM_CONFIG_KEY));

    return result[key] as SysConfig[T];
  },
  set<T extends keyof SysConfig>(key: T, value: any) {
    const config = systemStore.getConfig();
    config[key] = value;
    systemStore.setConfig(config);
  },
  getConfig: () =>
    JSON.parse(window.localStorage.getItem(SYSTEM_CONFIG_KEY) as unknown as SysConfig & string),
  setConfig: (config: SysConfig) =>
    window.localStorage.setItem(SYSTEM_CONFIG_KEY, JSON.stringify(config)),
};

export default systemStore;
